export default "__VITE_ASSET__DMxsUk95__"